
<div>
    <div class="col-12 mb-3">
        <h2 mat-dialog-title class="title-pdf">
                <img src="{{RESOURCE_SERVER_URL}}/assets/images/Cancel.svg" alt="Cancel Icon" mat-button mat-dialog-close >
        </h2>
    </div>
<div>
<mat-dialog-content class="content-pdf" [class.overflow-auto]="data?.typeFile == 'png' || data?.typeFile == 'jpg' || data?.typeFile == 'jpeg'">
    <ng-container *ngIf="data?.file">
        <ng-container *ngIf="data?.typeFile == 'png' || data?.typeFile == 'jpg' || data?.typeFile == 'jpeg'">
            <div class="view-image-file">
                <img src="data:image/{{data?.typeFile}};base64,{{ data?.file }}" alt="Image"/>
            </div>
        </ng-container>
        <ng-container *ngIf="data?.typeFile == 'pdf'">
            <ngx-extended-pdf-viewer [src]="data.file"  height="80vh" [showZoomButtons]="false" [showPagingButtons]="false" [showPrintButton]="false" >
            </ngx-extended-pdf-viewer>
        </ng-container>
        <div class="style-printbtn" *ngIf="data?.isShowButton == true">
            <custom-button  id="print_pdf" class="secondarybutton remove-button-shadow print_button" margin="xxsmall" mode="secondary"
            (onClick)="onPrintPDF()"
          [iconSrc]="srcPrintPdf" iconPosition="after"></custom-button>
        </div>
    </ng-container>
</mat-dialog-content>
</div>
</div>
